<template>
  <section v-if="requestId ? visibleHistory.length : loading || error || steps.length" class="my-5">
    <h4 class="content-heading text-black font-bold uppercase mb-3">Người duyệt thay thế</h4>
    <template v-if="!requestId">
      <p v-if="loading">Đang tải người duyệt…</p>
      <div v-if="error" class="text-danger">{{ error }} <el-button type="text" @click="load">Tải lại</el-button></div>
      <div v-for="step in steps" :key="step.step_id" class="mb-4">
        <label class="block mb-2">{{ step.step_name }}</label>
        <v-select v-model="selected[step.step_id]" :options="choicesFor(step)" label="name" :reduce="choice => choice.title_id" :selectable="choice => choice.title_id === 0 || choice.employees.length > 0" :clearable="false" class="bg-white w-full" :disabled="loading || !!error" @input="changed" placeholder="Theo quy trình mặc định">
          <template #no-options>Không tìm thấy người duyệt phù hợp.</template>
        </v-select>
        <p class="text-sm mt-1">Chọn một chức danh hoặc giữ người duyệt mặc định. Nếu có nhiều người đảm nhiệm, một người duyệt là chuyển bước.</p>
      </div>
    </template>
    <div v-for="row in visibleHistory" :key="row.step_id">
      <div class="flex mb-1">
        <label class="w-1/2 sm:w-1/4 text-gray-1 break-normal">Phòng ban:</label>
        <div class="w-1/2 sm:w-3/4 text-black">{{ row.department_name }}</div>
      </div>
      <div class="flex mb-1">
        <label class="w-1/2 sm:w-1/4 text-gray-1 break-normal">Chức danh:</label>
        <div class="w-1/2 sm:w-3/4 text-black">{{ row.title_name }}</div>
      </div>
      <div class="flex mb-1">
        <label class="w-1/2 sm:w-1/4 text-gray-1 break-normal">Người duyệt:</label>
        <div class="w-1/2 sm:w-3/4 text-black">{{ row.employees.map(employee => employee.name).join(", ") }}</div>
      </div>
    </div>
  </section>
</template>
<script>
import { Button } from "element-ui";
import vSelect from "vue-select";
import api from "@/http/requests/request/alternativeApprovers";
export default {
  components: { vSelect, ElButton: Button },
  props: {
    typeId: { type: [Number, String], default: null },
    requestId: { type: [Number, String], default: null },
    creatorId: { type: [Number, String], default: null },
    activeStepId: { type: [Number, String], default: null }
  },
  data() { return { steps: [], selected: {}, history: [], loading: false, error: "", generation: 0 }; },
  computed: {
    identity() { return JSON.stringify(this.$store.state.AppActiveUser || {}); },
    employeeId() { return Number((this.$store.state.AppActiveUser || {}).employee_id) || null; },
    canViewHistory() { return !!this.requestId && !!this.employeeId && Number(this.creatorId) === this.employeeId; },
    visibleHistory() {
      return this.canViewHistory ? this.history.filter(row => Number(row.step_id) === Number(this.activeStepId) && Number(row.selected_by) === this.employeeId) : [];
    },
    context() { return [this.typeId, this.requestId, this.creatorId, this.identity].join(":"); }
  },
  watch: { context: { immediate: true, handler() { this.load(); } } },
  beforeDestroy() { this.generation++; },
  methods: {
    choicesFor(step) { return [{ title_id: 0, name: "Theo quy trình mặc định", employees: [] }].concat(step.choices.map(choice => Object.assign({}, choice, { name: this.label(choice) }))); },
    label(choice) { return choice.title_name + " — " + choice.department_name + " (" + (choice.employees.map(e => e.name).join(", ") || "Không có người đủ điều kiện") + ")"; },
    async load() {
      const generation = ++this.generation;
      this.steps = []; this.history = []; this.selected = {}; this.error = "";
      if (!this.requestId) this.$emit("input", []);
      if ((!this.typeId && !this.requestId) || (this.requestId && !this.canViewHistory)) {
        this.loading = false;
        if (!this.requestId) this.$emit("busy", false);
        return;
      }
      this.loading = true;
      if (!this.requestId) this.$emit("busy", true);
      try {
        const result = this.requestId ? await api.history(this.requestId) : await api.options(this.typeId);
        if (generation !== this.generation) return;
        if (this.requestId) this.history = result;
        else { this.steps = result; result.forEach(s => this.$set(this.selected, s.step_id, 0)); }
      } catch (e) { if (generation === this.generation) this.error = e.message; }
      finally { if (generation === this.generation) { this.loading = false; if (!this.requestId) this.$emit("busy", !!this.error); } }
    },
    changed() {
      const selections = [];
      this.steps.forEach(step => {
        const choice = step.choices.find(c => c.title_id === this.selected[step.step_id]);
        if (choice) selections.push({ step_id: step.step_id, title_id: choice.title_id, preview_token: choice.preview_token });
      });
      this.$emit("input", selections);
    }
  }
};
</script>
